import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.app.wallet,
    props.app.cashapp,
    props.app.buttons.create_cashapp_cashout,
    props.app.buttons.confirm_cashapp_cashout,
    (wallet, cashapp, createButton, confirmButton) => {
        return {
            wallet,
            cashapp,
            createButton,
            confirmButton
        }
    }
)